<template>
  <div id="service_request_form">
    <div
      class="card w-100 my-3"
      ref="reason_btn"
      :id="item.reg_id"
      v-for="item in mymics"
      :key="item.reg_id"
      :class="selected===item.reg_id ? 'border-primary':''"
      @click="markAsSelected(item.reg_id, item)"
    >
      <div class="d-flex">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
          <img class="text-center img-fluid" :src="generateImgpath(item)" :alt="item.reg_id" />
        </div>
        <div class="col-8 col-lg-9 bg-light p-3">
          <h4 v-html="item.part_name"></h4>
          <hr />
          <h5 class="strong my-3">
            Serial number:
            <span v-html="item.serial_number"></span>
          </h5>
          <div class="my-3">
            <p v-html="item.purchase_date_string"></p>
          </div>
          <div class="my-3">
            <p v-html="item.source"></p>
          </div>
          <div class="my-3" v-show="item.warranty_length !== 0">
            <p v-html="item.warranty_expire"></p>
          </div>
          <div class="text-right" v-if="item.under_warranty">
            <i class="fa fa-check-circle text-success"></i> Under Warranty
          </div>
          <div class="text-right" v-if="!item.under_warranty">
            <i class="fa fa-times-circle text-danger"></i> Warranty Expired
          </div>
        </div>
      </div>
      <div
        v-if="selected===item.reg_id && (completed.indexOf(item.reg_id) >= 0) && (success_message !== '')"
      >
        <div class="m-3 alert alert-success" role="alert" v-html="success_message"></div>
      </div>
      <div v-if="selected===item.reg_id && (completed.indexOf(item.reg_id) < 0)">
        <div class="py-3 d-md-flex bg-light">
          <div v-for="(reason,key) in reasons" :key="key" class="col">
            <button
              @click="setReason(key)"
              type="button"
              class="btn w-100 h-100"
              :class="selected_reason === key ? 'btn-primary' : 'btn-light'"
              :value="key"
            >{{ reason }}</button>
          </div>
        </div>

        <form action="post" v-on:submit.prevent="onSubmit">
          <div class="col" v-if="selected_reason!==''">
            <div class="form-group">
              <label for="country">Country</label>
              <select name="country" class="form-control" v-model="selected_country" required>
                <option value>Select your country</option>
                <option v-for="(country, id) in countries" :key="id">{{ country }}</option>
              </select>
            </div>
            <div class="w-100" v-if="showAddressInput">
              <div class="form-group">
                <label>Your Postal Address:</label>
                <input
                  type="text"
                  name="full_address"
                  class="form-control"
                  :class="hasError('address') ? 'is-invalid' : ''"
                  v-model="address"
                  placeholder="Please supply your full postal address, do not use P.O. Box."
                  required
                />
              </div>
              <div class="form-group">
                <label>Your Contact Number:</label>
                <input
                  type="tel"
                  name="contact"
                  class="form-control"
                  :class="hasError('contact') ? 'is-invalid' : ''"
                  v-model="contact"
                  placeholder="Please supply your contact number."
                  required
                />
              </div>
            </div>
            <div class="w-100 form-group">
              <label>Describe the issue</label>
              <textarea
                required
                class="form-control"
                name="reason"
                cols="30"
                rows="10"
                placeholder="Describe the issue"
                v-model="message"
              ></textarea>
              <p>Please detail the issue that has occured as well as any other information that may be required.</p>
            </div>
            <div
              class="w-100 form-group terms_condition"
              @click="toggle_terms"
              :ref="item.reg_id"
              :class="hasError('terms') ? 'text-danger' : ''"
            >
              <i v-if="!terms_agreed" class="far fa-square"></i>
              <i v-if="terms_agreed" class="far fa-check-square text-success"></i>
              <span>
                I have read & agree to the
                <a
                  href="https://www.rode.com/termsofuse"
                  target="_blank"
                  class="text-gold"
                >Terms & Conditions</a>
              </span>
              <p
                class="text-danger"
                v-if="hasError('terms')"
              >You need to read and agree the terms and condition before submit your request.</p>
            </div>
            <div class="form-group">
              <button
                class="btn btn-rounded-0 btn-gold btn-goldborder"
                :disabled="submitting"
                type="submit"
              >
                <i class="fas fa-spinner" v-if="submitting"></i>
                <span v-if="submitting">Submitting...</span>
                <span v-if="!submitting">Submit service request</span>
              </button>
              <div
                class="alert alert-danger mt-3"
                role="alert"
                v-html="error_message"
                v-if="error_message !== ''"
              ></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      address: "",
      countries: [],
      completed: [],
      contact: "",
      errors: [],
      error_message: "",
      mymics: [],
      message: "",
      reasons: [],
      selected: "",
      selected_country: "",
      selected_reason: "",
      selected_reg: [],
      success_message: "",
      submitting: false,
      terms_agreed: false,
    };
  },
  methods: {
    hasError(field) {
      return this.errors.indexOf(field) >= 0;
    },
    markAsSelected(reg_id, reg) {
      if (this.selected !== reg_id) {
        this.address = "";
        this.contact = "";
        this.message = "";
        this.errors = [];
        (this.error_message = ""), (this.selected_reason = "");
        this.selected_reg = reg;
        this.selected = reg_id;
        this.submitting = false;
        (this.success_message = ""), (this.terms_agreed = false);
      }
    },
    setReason(r) {
      this.selected_reason = r;
    },
    generateImgpath(item) {
      let img_url =
        "https://cdn2.rode.com/images/products/" +
        item.part_number +
        "/" +
        item.part_number +
        ".png";
      return img_url;
    },
    toggle_terms() {
      this.terms_agreed = !this.terms_agreed;
    },
    onSubmit() {
      this.errors = [];
      let form_has_error = false;
      let message = this.message;
      let internal_message = "Reg No:\n" + this.selected;
      internal_message += "\n\nPart:\n" + this.selected_reg["part_number"];
      if (!this.terms_agreed) {
        this.errors.push("terms");
        form_has_error = true;
      } else {
        if (this.showAddressInput) {
          if (this.address.trim() == "") {
            this.errors.push("address");
            form_has_error = true;
          }
          if (this.contact.trim() == "") {
            this.errors.push("contact");
            form_has_error = true;
          }
          if (form_has_error === false) {
            internal_message += "\n\nPostal Address:\n" + this.address + " " + this.selected_country;
            internal_message += "\n\nContact Number:\n" + this.contact;
          }
        }
      }
      if (form_has_error === false) {
        this.submitting = true;
        axios
          .post("/post_request", {
            country: this.selected_country,
            dealername: this.source,
            email: this.userEmail,
            message: message,
            internal_message: internal_message,
            name: this.userName,
            product: this.selected_reg["part_number"],
            purhcasedate: this.selected_reg["date_of_purhcase"],
            reason: this.selected_reason,
            reg_id: this.selected,
            serialnumber: this.selected_reg["serial_number"],
            subject: this.reasons[this.selected_reason],
          })
          .then((response) => {
            this.completed.push(this.selected);
            if (typeof response.data !== "undefined") {
              this.success_message = response.data.message;
            }
            this.submitting = false;
          })
          .catch((error) => {
            console.error(error);
            if (typeof error.response !== "undefined") {
              let response = error.response;
              this.error_message = response.data.error;
            }
            this.submitting = false;
          }); 
      }
    },
  },
  props: {
    userCountries: {
      type: String,
      default: "",
    },
    myMics: {
      type: String,
      default: "",
    },
    userReasons: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
    userEmail: {
      type: String,
      default: "",
    },
  },
  mounted() {
    let myMics = JSON.parse(this.myMics);
    for (const key in myMics) {
      if (myMics.hasOwnProperty(key)) {
        const mymic = myMics[key];
        this.mymics.push(mymic);
      }
    }
    this.reasons = JSON.parse(this.userReasons);
    this.countries = JSON.parse(this.userCountries);
  },
  computed: {
    showAddressInput: function () {
      return (
        this.selected_reason === "tech_spare" ||
        this.selected_reason === "tech_support"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#service_request_form {
  .terms_condition {
    cursor: pointer;
  }
}
</style>